import { Button } from '@tark/shared/components';
import { useNavigate } from 'react-router-dom';
import type { CoachNextSessionPanelProps } from './coachStudioTypes';
import { formatCompactDate, formatSessionWindow } from './coachStudioUtils';
export default function CoachNextSessionPanel(p: CoachNextSessionPanelProps) {
  const navigate = useNavigate(); const o = p.occurrence;
  const booked=p.rosterSummary?.bookedCount;
  const capacity=p.rosterSummary?.capacity ?? o?.capacity;
  const attendance=p.attendanceSummary;
  const marked=(attendance?.presentCount??0)+(attendance?.lateCount??0)+(attendance?.absentCount??0)+(attendance?.excusedCount??0);
  const required=attendance?.requiredCount??booked??0;
  return <section className="tk-panel p-4" aria-label="Next session">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0"><p className="text-xs font-semibold text-primary">Next session</p><h2 className="mt-1">{o?.title || 'No session queued'}</h2>
        {o&&<p className="mt-1 text-xs text-text-muted">{formatCompactDate(o.startsAt)} · {formatSessionWindow(o.startsAt,o.endsAt)} · {o.locationLabel || o.programName}</p>}
      </div>
      <Button onClick={()=>o?navigate(`/schedule/roster/${o.occurrenceId}`):p.onOpenWork()}>{o?'Open Roster':'Open Schedule'}</Button>
    </div>
    {o&&<div className="mt-3 flex flex-wrap gap-x-5 gap-y-2 border-t border-border pt-3 text-xs text-text-muted">
      {p.isLoading?<span role="status">Loading roster state…</span>:<><span>Roster <b className="text-text">{booked??'—'}{capacity!=null?`/${capacity}`:''}</b></span><span>Check-in <b className="text-text">{marked}/{required}</b></span>
      {(p.openSpotCount??0)>0&&<span><b>{p.openSpotCount}</b> open spots</span>}{(p.makeupSummary?.openCount??0)>0&&<span><b>{p.makeupSummary?.openCount}</b> makeups</span>}{p.slotFillerCount>0&&<span><b>{p.slotFillerCount}</b> fillers ready</span>}</>}
    </div>}
  </section>;
}
